import { useAnalytics, useAnalyticsAttributes } from "../../../components";

import {
    Button,
    ButtonGroup,
    PrimaryButton,
    PrimaryButtonDark
} from "./Buttons.styles";

export type HeaderNavButtonsProps = {
    readonly goToBoardsText?: string;
    readonly logInText?: string;
    readonly signUpText?: string;
    readonly signUpUrl: string;
    readonly loginUrl: string;
    readonly isLoggedIn?: boolean;
    readonly uuid: string;
};

const Buttons = ({
    goToBoardsText,
    logInText,
    signUpText,
    signUpUrl,
    loginUrl,
    isLoggedIn,
    uuid
}: HeaderNavButtonsProps) => {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();

    // When login state is not yet known render nothing — no layout shift risk
    // since ButtonGroup uses margin-left:auto and collapses cleanly.
    if (isLoggedIn === undefined) {
        return null;
    }

    return isLoggedIn === true && goToBoardsText ? (
        <ButtonGroup>
            <PrimaryButtonDark
                href="/"
                onClick={() =>
                    sendTrackEvent("clickedGlobalNavButton", {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: "globalNavButton",
                        label: goToBoardsText,
                        labelEnglish: "Go to your boards",
                        href: "/",
                        uuid: `${uuid}_goToBoards`
                    })
                }
                data-uuid={`${uuid}_goToBoards`}
            >
                {goToBoardsText}
            </PrimaryButtonDark>
        </ButtonGroup>
    ) : (
        <ButtonGroup>
            {logInText && (
                <Button
                    href={loginUrl}
                    onClick={() =>
                        sendTrackEvent("clickedGlobalNavButton", {
                            ...analyticsAttributes,
                            event: "clicked",
                            eventComponent: "globalNavButton",
                            label: logInText,
                            labelEnglish: "Log in",
                            href: loginUrl,
                            uuid: `${uuid}_logIn`
                        })
                    }
                    data-uuid={`${uuid}_login`}
                >
                    {logInText}
                </Button>
            )}
            {signUpText && (
                <PrimaryButton
                    href={signUpUrl}
                    onClick={async () => {
                        const recaptcha_key = window.location.href?.includes(
                            "trello.com"
                        )
                            ? "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD"
                            : "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";
                        try {
                            await new Promise<void>((resolve) => {
                                window.grecaptcha.ready(() => resolve());
                            });
                            await window.grecaptcha.execute(recaptcha_key, {
                                action: "trello_submit"
                            });
                        } catch (error) {
                            console.error("reCAPTCHA error:", error);
                            // Optionally handle the error, e.g. show an error message to the user
                        }
                        return sendTrackEvent("clickedGlobalNavButton", {
                            ...analyticsAttributes,
                            event: "clicked",
                            eventComponent: "globalNavButton",
                            label: signUpText,
                            labelEnglish: "Get Trello for free",
                            href: signUpUrl,
                            uuid: `${uuid}_signup`
                        });
                    }}
                    data-uuid={`${uuid}_signup`}
                >
                    {signUpText}
                </PrimaryButton>
            )}
        </ButtonGroup>
    );
};

export default Buttons;
